import {
  Spinner,
  Text,
  VStack,
  Box,
} from '@gluestack-ui/themed';
import { useNavigation } from '@react-navigation/native';
import React from 'react';

import SubmissionItem from './SubmissionItem';

interface Submission {
  id: string;
  moduleId: string;
  moduleName: string;
  userId: string;
  userName: string;
  dueDate: string;
  grading?: {
    grade: string;
  };
}

interface Module {
  id: string;
  title: string;
}

interface SubmissionListProps {
  visible: boolean;
  module: Module | null;
  submissions: Submission[];
  isLoading: boolean;
}

const SubmissionList: React.FC<SubmissionListProps> = ({
  visible,
  module,
  submissions,
  isLoading,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const navigation = useNavigation<any>();

  const handlePress = (submission: Submission) => {
    // When module is not provided, create a minimal module object from the submission
    const moduleParam = module || { id: submission.moduleId, title: submission.moduleName };
    navigation.navigate('EvaluationDesk', { module: moduleParam, submission });
  };

  if (!visible) {
    return null;
  }

  if (isLoading) {
    return (
      <Box p="$4" alignItems="center">
        <Spinner />
      </Box>
    );
  }

  return (
    <VStack space="sm" testID="submission-list">
      {!submissions || submissions.length === 0 ? (
        <Box px="$4" py="$3">
          <Text size="sm" color="$textSubtle" textAlign="center">
            No pending submissions
          </Text>
        </Box>
      ) : (
        submissions.map((submission) => (
          <SubmissionItem
            key={`${submission.moduleId}-${submission.userId}`}
            submission={submission}
            onPress={() => handlePress(submission)}
            showModuleName={!module?.id} // Show module name when viewing all submissions
          />
        ))
      )}
    </VStack>
  );
};

export default SubmissionList;
